/**
 * Small pieces of the suggested data models (docs/model-suggestions.md) in Settings → Data model → Your data models:
 * the confidence as bars and a word. The suggestions are listed in the model list as a quiet group of their own and
 * shown, when chosen, like a model (pages/Models.tsx).
 */
import { cx } from '../design/primitives.tsx';

/** High / Medium / Low, as three bars and a word (never colour alone). */
export function confidenceWord(c: number): 'High' | 'Medium' | 'Low' {
  return c >= 0.8 ? 'High' : c >= 0.6 ? 'Medium' : 'Low';
}

export function Confidence({ value, short = false }: { value: number; short?: boolean }) {
  const word = confidenceWord(value);
  const bars = word === 'High' ? 3 : word === 'Medium' ? 2 : 1;
  return (
    <span className="inline-flex items-center gap-1.5 text-micro text-n8 whitespace-nowrap" title={`Confidence ${Math.round(value * 100)} %`}>
      <span className="inline-flex items-end gap-[2px]" aria-hidden="true">
        {[0, 1, 2].map((i) => <span key={i} className={cx('w-[3px] rounded-[1px]', i < bars ? 'bg-n9' : 'bg-n5')} style={{ height: 6 + i * 3 }} />)}
      </span>
      {short ? word : `${word} confidence`}
    </span>
  );
}
